import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import InputBox from "../../../common/interactive/InputBox"
import HoverWrapperInfo from "../../../wrappers/HoverWrapperInfo"
import { useDispatch, useSelector } from "react-redux"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate } from "../../../../lib/fetchApi"

export default function LienBookPage({item, fullData, propType}) {
    const dispatch = useDispatch()
    let userPermissionEditBookAndPage = useUserTabEditPermissionDisabled('lien_book_page_edit')
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)


    async function updateHandler(data) {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            

            // dispatch(caseActions.updateAddLien({
            //     case_practice_id: drawerData.id,
            //     content: update
            // }))
            dispatch(caseActions.updateLienProperty({
                case_practice_id: fullData.id,
                id: item.id,
                property: data.identifier.field,
                value: data.data.value
            }))
        }        
    }
    return <>
        {userPermissionEditBookAndPage && <>
            <InputBox currentValue={item[propType]} identifier={{type: 'case_lien', field: propType, type_id: item.id}} setStyle={'simple'} action={updateHandler}/>
        </>}
        {!userPermissionEditBookAndPage && <HoverWrapperInfo modalText={'Book'} >
            {item[propType]}
        </HoverWrapperInfo>}
    </>
}